import { Directive } from 'vue'

type ClickOutsideElement = HTMLElement & { clickOutsideEvent?: (event: MouseEvent) => void }

/**
 * Element clickoutside is not prepared to listen to events inside a child,
 * so I added a new directive
 */
const clickOutside: Directive<ClickOutsideElement, (event: MouseEvent) => void> = {
  mounted(el, binding) {
    el.clickOutsideEvent = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
}

export default clickOutside
